<template>
    <div class="loginBody">

      <!-- 全局头部导航（Logo / 登录区 / 菜单 / 登录抽屉） -->
      <header-nav></header-nav>

      <div class="video">
        <video autoplay muted loop>
          <source src="../assets/video/about.mp4" type="video/mp4">
        </video>
      </div>

      <div class="box">
        <svg viewBox="0 0 200 200" version="1.1">
          <text font-family="爱心字体, sans-serif" x="50%" y="55%" text-anchor="middle">粉裙星物语</text>
        </svg>
      </div>

<div class="login-aa">
  <img src="../assets/img/AA.png" class="login-aa-img">
</div>


      <div class="Login-game">
        <home-game></home-game>
      </div>


      <div>
      <section class="banner">
        <h1>Lolita · JK · 汉服<br>少女洋装与国风之美</h1>
        <p>收集世间温柔可爱，感受洛丽塔的甜系优雅，JK制服的青春元气，汉服独有的东方古韵，赴一场浪漫穿搭盛宴。</p>
        <div class="scroll-tip">↓ 向下滑动探索更多 ↓</div>
      </section>
        <home-showcase></home-showcase>
    </div>

      <!-- ============ 页脚：可爱幻境 ============ -->
      <footer class="dream-footer">
        <div class="df-inner">

          <!-- 标题区 -->
          <div class="df-header">
            <h2 class="df-title">🌸陪伴与童真并存的可爱幻境🌸</h2>
            <p class="df-subtitle">
              <span class="df-line"></span>
              🌸后来才懂，很多故事只有回忆，没有结局🌸
              <span class="df-line"></span>
            </p>

            <!-- 六个心情卡片 -->
            <div class="df-moods">
              <div class="df-mood" v-for="mood in moods" :key="mood.name">
                <span class="df-mood-icon">{{ mood.icon }}</span>
                <span class="df-mood-name">{{ mood.name }}</span>
              </div>
            </div>

            <!-- 两个按钮 -->
            <div class="df-btns">
              <button type="button" class="df-btn df-btn-primary">🌸旧梦难寻🌸</button>
              <button type="button" class="df-btn df-btn-ghost">🌸浮生怅忆🌸</button>
            </div>
          </div>

          <div class="df-divider"></div>

          <!-- 底部信息区 -->
          <div class="df-body">
            <!-- 品牌 + 二维码 -->
            <div class="df-brand">
              <img class="df-planet" src="../assets/img/xy.gif" alt="粉裙星球">
              <div class="df-qrcodes">
                <div class="df-qrcode">
                  <img src="../assets/img/imgtu.jpg" alt="粉裙公众号二维码">
                  <span>粉裙公众号</span>
                </div>
                <div class="df-qrcode">
                  <img src="../assets/img/imgtui.jpg" alt="微信咨询二维码">
                  <span>微信咨询</span>
                </div>
              </div>
            </div>

            <!-- 意境词链接列 -->
            <div class="df-links">
              <div class="df-link-col" v-for="col in linkCols" :key="col.title">
                <h4>{{ col.title }}</h4>
                <a href="javascript:void(0)" v-for="item in col.items" :key="item">{{ item }}</a>
              </div>
            </div>

            <!-- 联系方式 -->
            <div class="df-contact">
              <h4>联系我们</h4>
              <p class="df-contact-item">📞 000-000-0000<span class="df-contact-note">工作日 9:30-18:30</span></p>
              <p class="df-contact-item">✉️ 778194576@qq.com</p>
              <p class="df-contact-item">📍 湖北省武汉市</p>
            </div>
          </div>

          <!-- 版权条 -->
          <div class="df-copyright">
            © 2026 粉裙 ｜ ICP备 暂无 ｜ 公网安备 无 ｜ 迷失幻境忆梦 ｜ 版权所有 粉裙星物语
          </div>
        </div>
      </footer>

    </div>
</template>


<script>
    import HomeGame from './HomeGame'
    import HeaderNav from './HeaderNav'
    import HomeShowcase from './HomeShowcase/HomeShowcase.vue'
    export default {
        name: "Home",
        components: { HomeGame, HeaderNav, HomeShowcase },
        data(){
            return{
              activeIndex: '1',
              // 页脚六个心情卡片
              moods: [
                { name: '怅惘', icon: '💭' },
                { name: '余念', icon: '🌙' },
                { name: '绮梦', icon: '🦋' },
                { name: '旧殇', icon: '🥀' },
                { name: '惘然', icon: '🌧️' },
                { name: '憾然', icon: '🍃' }
              ],
              // 页脚意境词链接列
              linkCols: [
                { title: '热门穿搭', items: ['往事沉疴', '旧梦难寻', '物是人非', '万般怅然'] },
                { title: '粉裙星物语', items: ['回不去矣', '满目唏嘘', '忆起潸然', '意难释怀'] },
                { title: '疑惑', items: ['旧绪翻涌', '无可奈何', '浮生怅忆'] },
                { title: '旧殇', items: ['往事难追', '加入我们', '旧事难平', '荧惑罪忆'] }
              ]
            }
        },
        watch:{
            // 顶部导航“分类项”带 jump 参数跳回首页时，滚动到对应板块
            '$route.query.jump'(val){
                if(val) this.scrollToJump(val)
            }
        },
        methods:{
            // 滚动到指定板块（style=三大风格介绍，showcase=服饰样例展示）
            scrollToJump(jump){
                const el = document.getElementById(jump === 'showcase' ? 'showcase' : 'style')
                if(el){
                    el.scrollIntoView({ behavior:'smooth', block:'start' })
                }
            }
        },
        created(){
            // 从顶部导航带 jump 参数进入时，滚动到对应板块
            if(this.$route.query.jump){
                this.$nextTick(() => this.scrollToJump(this.$route.query.jump))
            }
        }
    }
</script>

<style scoped>
body {
  padding-top: 60px; /* 根据导航高度调整，一般 el-menu 高度约 60px */
}
    .loginBody {

        width: 100%;
        height: 100%;
        position: relative;
      //background:linear-gradient(45deg,rgba(85, 255, 255, 0.6), rgba(255, 170, 255, 1),rgba(255, 255, 127, 0.6));
      //background-image: url("../assets/img/login-3.png") ;
      background-size: 100% 100%;
    }

.box{
      top: 112px;
      position:absolute;
      width: 100%;
      height: 240px;

    }
    .login-aa{
      top: 80px;
      display: flex;
      position: absolute;
      right: 30px;
    }
    .login-aa-img{
      height: 200px;
      width: 200px;
    }
    .video{

      display: flex;
      width: 100%;
      height: 900px;
      //z-index: -1;

    }
    .video video{
      top: 60px;
      //right: 0;
      position: absolute;
      width: 100%;
      height: 840px;
      //height: 90%;
      object-fit: cover;
      z-index: -1;
    }
    svg{
      width: 100%;
      height: 100%;
    }
@font-face {
  font-family: '爱心字体';          /* 起个名字 */
  src: url('../assets/fonts/爱心字体.ttf') format('truetype');
}
    svg text{
      font-size: 100px;
      fill: rgba(148, 74, 0,0);
      stroke-width: 2px;
      stroke: rgb(121, 210, 241);
      //stroke: #cccccc8c;
      stroke-dasharray: 1000;
      stroke-dashoffset:1000;
      animation-name:txtain;
      animation: txtain-loop 15s infinite;
      //animation-iteration-count: infinite;
      animation-timing-function: linear; /* 添加速度曲线 */
    }
    @keyframes txtain{
      from{
        stroke-dashoffset:1000;
      }
      to{
        stroke-dashoffset:0;
      }
    }

    @keyframes txtain-loop {
      0% {
        animation-timing-function: linear;
        stroke-dashoffset: 1000;
      }
      44.44% { /* 8s / 18s ≈ 44.44% */
        animation-timing-function: linear;
        stroke-dashoffset: 0;
      }
      44.44%, 100% { /* 从44.44%到100%是停留时间，即10s */
        stroke-dashoffset: 0; /* 保持描边完成状态 */
        animation-timing-function: steps(1, end); /* 确保在这段时间内不发生变化 */

      }
    }
    .Login-game{
      /* 悬浮在视频背景盒子区域的中间 */
      position: absolute;
      left: 50%;
      top: 500px;
      transform: translate(-50%, -50%);
      width: min(860px, 90vw);
      height: 340px;
      z-index: 5;
      //background: rgba(255, 255, 255, 0.22);
      //border-radius: 24px;
      //border: 2px solid rgba(255, 255, 255, 0.55);
      //box-shadow: 0 14px 44px rgba(233, 96, 152, 0.28);
      //backdrop-filter: blur(6px);
      //-webkit-backdrop-filter: blur(6px);
      overflow: hidden;
    }





    /*首页横幅*/
    .banner {
      position: relative;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 0 2rem;
      overflow: hidden;
      background:
        radial-gradient(circle at 15% 20%, rgba(252, 178, 217, 0.5), transparent 50%),
        radial-gradient(circle at 85% 75%, rgba(190, 175, 255, 0.55), transparent 50%),
        radial-gradient(circle at 50% 100%, rgba(255, 208, 165, 0.5), transparent 50%),
        linear-gradient(160deg, #ffe6ef, #fff0f8);
      background-size: 200% 200%, 200% 200%, 200% 200%, 100% 100%;
      animation: glow-flow 14s ease-in-out infinite alternate
    }
    /* 背景光晕缓慢流动（三色对比分明） */
    @keyframes glow-flow {
      0% { background-position: 0% 0%, 100% 100%, 50% 50%, 0 0 }
      50% { background-position: 100% 50%, 0% 20%, 90% 20%, 0 0 }
      100% { background-position: 30% 100%, 80% 0%, 10% 90%, 0 0 }
    }

    /* 横幅内星光闪烁 */
    .banner::before {
      content: "";
      position: absolute;
      inset: 0;
      background-image:
        radial-gradient(2px 2px at 20% 25%, rgba(255, 255, 255, 0.9), transparent),
        radial-gradient(1.5px 1.5px at 40% 60%, rgba(255, 200, 230, 0.9), transparent),
        radial-gradient(2px 2px at 65% 30%, rgba(255, 255, 255, 0.8), transparent),
        radial-gradient(1.5px 1.5px at 80% 65%, rgba(255, 190, 225, 0.85), transparent),
        radial-gradient(1px 1px at 30% 80%, rgba(255, 255, 255, 0.7), transparent),
        radial-gradient(2px 2px at 90% 20%, rgba(255, 180, 220, 0.8), transparent),
        radial-gradient(1.5px 1.5px at 55% 85%, rgba(255, 255, 255, 0.75), transparent);
      animation: star-flicker 5s ease-in-out infinite;
      pointer-events: none;
      z-index: 0;
    }
    @keyframes star-flicker {
      0%, 100% { opacity: 0.55 }
      50% { opacity: 1 }
    }

    /* 横幅浮动光斑 */
    .banner::after {
      content: "";
      position: absolute;
      width: 340px;
      height: 340px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(255, 190, 225, 0.5), transparent 65%);
      filter: blur(30px);
      animation: float-blob 11s ease-in-out infinite;
      pointer-events: none;
      z-index: 0;
    }
    @keyframes float-blob {
      0%, 100% { transform: translate(0, 0) scale(1) }
      33% { transform: translate(46px, -34px) scale(1.12) }
      66% { transform: translate(-32px, 22px) scale(0.94) }
    }

    .banner h1 {
      position: relative;
      z-index: 1;
      font-size: clamp(2.4rem, 6vw, 4rem);
      margin-bottom: 16px;
      background: linear-gradient(120deg, #d95a96, #ff9ecb, #a97fe8, #d95a96);
      background-size: 300% 100%;
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: title-gradient 6s linear infinite;
      filter: drop-shadow(0 2px 10px rgba(255, 170, 215, 0.5));
    }
    @keyframes title-gradient {
      to { background-position: 300% 0; }
    }
    /* 标题下方花饰装饰线 */
    .banner h1::after {
      content: "❀ ✦ ❀";
      display: block;
      margin-top: 12px;
      font-size: 18px;
      letter-spacing: 14px;
      color: #e889b0;
      filter: drop-shadow(0 0 6px rgba(255, 150, 210, 0.6));
      animation: twinkle 2.4s ease-in-out infinite;
    }
    @keyframes twinkle {
      0%, 100% { opacity: 0.65 }
      50% { opacity: 1 }
    }

    .banner p {
      position: relative;
      z-index: 1;
      font-size: 18px;
      color: #77445c;
      max-width: 650px;
      line-height: 1.8
    }

    .scroll-tip {
      position: relative;
      z-index: 1;
      margin-top: 40px;
      font-size: 22px;
      animation: bounce 2s infinite;
      color: #e889b0;
      text-shadow: 0 0 12px rgba(255, 150, 210, 0.65);
      filter: drop-shadow(0 0 8px rgba(255, 170, 215, 0.45));
    }

    @keyframes bounce {

      0%,
      100% {
        transform: translateY(0)
      }

      50% {
        transform: translateY(10px)
      }
    }
    /*通用区块*/
    section {
      padding: 80px 5%;
      scroll-margin-top: 70px; /* 顶部导航固定定位，滚动定位时让出高度 */
    }

    .section-title {
      text-align: center;
      font-size: 34px;
      color: #b84f80;
      margin-bottom: 50px;
      position: relative
    }

    .section-title::after {
      content: "";
      width: 100px;
      height: 3px;
      background: #ff98c2;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -12px;
      border-radius: 3px
    }

    /*服饰卡片容器*/
    .gallery-wrap {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
      gap: 36px
    }

    .card {
      background: white;
      border-radius: 22px;
      overflow: hidden;
      box-shadow: 0 6px 18px #ffd8e8;
      transition: 0.4s ease;
      position: relative
    }

    .card:hover {
      transform: translateY(-12px);
      box-shadow: 0 12px 30px #ffb8d8
    }

    .card-img {
      width: 100%;
      height: 260px;
      background: linear-gradient(135deg, #ffd6e7, #ffe6f2);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 70px
    }

    .card-body {
      padding: 22px
    }

    .card-body h3 {
      font-size: 22px;
      color: #c25286;
      margin-bottom: 10px
    }

    .card-body p {
      color: #704256;
      line-height: 1.7;
      font-size: 15px
    }

    .tag-group {
      margin-top: 14px;
      display: flex;
      gap: 8px;
      flex-wrap: wrap
    }

    .tag {
      padding: 4px 12px;
      background: #ffe0ec;
      border-radius: 16px;
      font-size: 13px;
      color: #b04c7a
    }

    /*三大品类介绍区*/
    .intro-container {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      gap: 32px;
      margin-top: 20px
    }

    .intro-box {
      padding: 32px 24px;
      background: rgba(255, 232, 242, 0.75);
      border-radius: 24px;
      border: 1px solid #ffcce0;
      transition: 0.3s
    }

    .intro-box:hover {
      background: #ffe0ee;
      transform: scale(1.02)
    }

    .intro-box h2 {
      font-size: 24px;
      margin-bottom: 14px;
      color: #bd4e82
    }












  /* ==================== 页脚：可爱幻境 ==================== */
  .dream-footer {
    position: relative;
    overflow: hidden;
    margin-top: 50px;
    padding: 72px 0 30px;
    background:
      radial-gradient(circle at 12% 18%, rgba(255, 255, 255, 0.85) 0 2px, transparent 3px),
      radial-gradient(circle at 78% 12%, rgba(255, 255, 255, 0.7) 0 2px, transparent 3px),
      radial-gradient(circle at 58% 68%, rgba(255, 255, 255, 0.6) 0 2px, transparent 3px),
      radial-gradient(circle at 30% 82%, rgba(255, 255, 255, 0.55) 0 1.5px, transparent 2.5px),
      radial-gradient(circle at 90% 75%, rgba(255, 255, 255, 0.6) 0 2px, transparent 3px),
      linear-gradient(170deg, #fff0f7 0%, #f6e4fb 55%, #ece2fb 100%);
  }
  .dream-footer::before {
    content: "";
    position: absolute;
    top: -120px;
    left: 50%;
    transform: translateX(-50%);
    width: 720px;
    height: 320px;
    background: radial-gradient(ellipse at center, rgba(255, 158, 197, 0.35), transparent 70%);
    pointer-events: none;
  }
  .df-inner {
    position: relative;
    z-index: 1;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
  }

  /* 标题 */
  .df-header { text-align: center; }
  .df-title {
    margin: 0 0 18px;
    font-size: clamp(26px, 4vw, 40px);
    font-weight: 800;
    letter-spacing: 2px;
    background: linear-gradient(90deg, #ff8fc7, #b07cff, #ff8fc7);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    filter: drop-shadow(0 4px 10px rgba(217, 90, 150, 0.25));
  }
  .df-subtitle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
    margin: 0 0 42px;
    font-size: clamp(13px, 1.6vw, 17px);
    color: #a06a8c;
  }
  .df-line {
    width: 70px;
    height: 1px;
    background: linear-gradient(90deg, transparent, #ff9ec5);
  }
  .df-subtitle .df-line:last-child {
    background: linear-gradient(90deg, #ff9ec5, transparent);
  }

  /* 六个心情卡片 */
  .df-moods {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 16px;
    max-width: 1000px;
    margin: 0 auto 42px;
  }
  .df-mood {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 24px 10px;
    background: rgba(255, 255, 255, 0.75);
    border: 1px solid rgba(255, 158, 197, 0.4);
    border-radius: 18px;
    cursor: pointer;
    backdrop-filter: blur(6px);
    box-shadow: 0 4px 14px rgba(255, 158, 197, 0.18);
    transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease, border-color 0.3s ease;
  }
  .df-mood:hover {
    transform: translateY(-8px);
    background: #fff;
    border-color: #ffb3d4;
    box-shadow: 0 14px 26px rgba(217, 90, 150, 0.28);
  }
  .df-mood-icon {
    font-size: 38px;
    line-height: 1;
    transition: transform 0.3s ease;
  }
  .df-mood:hover .df-mood-icon { transform: scale(1.18) rotate(-8deg); }
  .df-mood-name {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    color: #b84f80;
  }

  /* 按钮 */
  .df-btns {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 18px;
  }
  .df-btn {
    padding: 13px 36px;
    border: none;
    border-radius: 999px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 2px;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease, color 0.3s ease;
  }
  .df-btn-primary {
    color: #fff;
    background: linear-gradient(135deg, #ff8fc7, #b07cff);
    box-shadow: 0 8px 20px rgba(217, 90, 150, 0.35);
  }
  .df-btn-primary:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 26px rgba(176, 124, 255, 0.42);
  }
  .df-btn-ghost {
    color: #d95a96;
    background: rgba(255, 255, 255, 0.85);
    border: 2px solid #ffb3d4;
  }
  .df-btn-ghost:hover {
    transform: translateY(-3px);
    color: #a97fe8;
    border-color: #b07cff;
  }

  /* 分隔线 */
  .df-divider {
    height: 1px;
    margin: 46px auto;
    background: linear-gradient(90deg, transparent, rgba(255, 158, 197, 0.6), rgba(176, 124, 255, 0.6), transparent);
  }

  /* 底部三栏信息 */
  .df-body {
    display: grid;
    grid-template-columns: 1.1fr 2fr 1fr;
    gap: 40px;
    align-items: start;
  }
  .df-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
  }
  .df-planet {
    width: 120px;
    height: auto;
    filter: drop-shadow(0 6px 14px rgba(176, 124, 255, 0.3));
    animation: df-float 4s ease-in-out infinite;
  }
  @keyframes df-float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
  .df-qrcodes { display: flex; gap: 14px; }
  .df-qrcode {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 10px;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 4px 12px rgba(255, 158, 197, 0.2);
  }
  .df-qrcode img {
    width: 84px;
    height: 84px;
    object-fit: cover;
    border-radius: 8px;
  }
  .df-qrcode span { font-size: 12px; color: #a06a8c; }

  /* 意境词链接列 */
  .df-links {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }
  .df-link-col h4,
  .df-contact h4 {
    margin: 0 0 14px;
    font-size: 15px;
    font-weight: 700;
    color: #b84f80;
  }
  .df-link-col h4 {
    position: relative;
    padding-bottom: 8px;
  }
  .df-link-col h4::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 24px;
    height: 2px;
    border-radius: 2px;
    background: #ff9ec5;
  }
  .df-link-col a {
    display: block;
    font-size: 13px;
    line-height: 30px;
    white-space: nowrap;
    text-decoration: none;
    color: #8a5f78;
    transition: color 0.2s ease, transform 0.2s ease;
  }
  .df-link-col a:hover {
    color: #d95a96;
    transform: translateX(4px);
  }

  /* 联系方式 */
  .df-contact-item {
    margin: 0 0 14px;
    font-size: 13px;
    line-height: 1.6;
    color: #8a5f78;
  }
  .df-contact-note {
    display: block;
    margin-top: 2px;
    font-size: 11px;
    color: #b48aa3;
  }

  /* 版权条 */
  .df-copyright {
    margin-top: 44px;
    padding-top: 22px;
    border-top: 1px solid rgba(255, 158, 197, 0.35);
    font-size: 12px;
    line-height: 1.9;
    text-align: center;
    color: #a8849c;
  }

/* ================= 平板适配（≤992px） ================= */
@media (max-width: 992px) {
  /* 心情卡片：3 列 */
  .df-moods { grid-template-columns: repeat(3, 1fr); }

  /* 信息区：单列堆叠，品牌区横向排列 */
  .df-body {
    grid-template-columns: 1fr;
    gap: 30px;
    justify-items: center;
  }
  .df-brand {
    flex-direction: row;
    gap: 26px;
  }
  .df-links {
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  .df-contact { width: 100%; }
}

/* ================= 手机端适配（≤767px） ================= */
@media (max-width: 767px) {

  /* 视频区：改为自适应高度，避免手机端 900px 占满整屏 */
  .video {
    height: auto;
  }
  .video video {
    height: 60vh;
    top: 60px;
  }

  /* 顶部描边大标题：缩小字号与位置 */
  .box {
    top: 76px;
    height: 110px;
  }
  svg text {
    font-size: 44px;
  }

  /* 右上角装饰图缩小 */
  .login-aa {
    right: 14px;
    top: 64px;
  }
  .login-aa-img {
    height: 84px;
    width: 84px;
  }

  /* 登录游戏卡片：跟随视口高度定位 */
  .Login-game {
    top: 46vh;
    width: 94vw;
    height: 300px;
  }

  /* 首页横幅文字缩小 */
  .banner p {
    font-size: 14px;
    padding: 0 4px;
  }
  .banner::after {
    width: 180px;
    height: 180px;
  }
  .scroll-tip {
    font-size: 15px;
    margin-top: 24px;
  }

  /* 通用区块收窄 */
  section {
    padding: 48px 4%;
  }
  .section-title {
    font-size: 26px;
    margin-bottom: 32px;
  }

  /* ===== 页脚适配（手机） ===== */
  .dream-footer {
    margin-top: 36px;
    padding: 48px 0 24px;
  }
  .df-subtitle {
    gap: 10px;
    margin-bottom: 30px;
  }
  .df-line { width: 40px; }

  /* 心情卡片：2 列 */
  .df-moods {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-bottom: 30px;
  }
  .df-mood {
    padding: 18px 8px;
    gap: 8px;
  }
  .df-mood-icon { font-size: 32px; }
  .df-mood-name { font-size: 15px; }

  /* 按钮：竖排居中 */
  .df-btns {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
  .df-btn {
    width: 220px;
    padding: 12px 0;
  }

  .df-divider { margin: 32px auto; }

  /* 信息区：单列居中 */
  .df-body {
    grid-template-columns: 1fr;
    gap: 32px;
    justify-items: center;
  }
  .df-brand {
    flex-direction: column;
    gap: 18px;
  }
  .df-links {
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
    gap: 22px 16px;
  }
  .df-contact { width: 100%; }

  .df-copyright {
    margin-top: 32px;
    font-size: 11px;
  }
}
</style>
